import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authService: AuthService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!!this.authService.getUser()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.getUserToken()}`,
        },
      });
    }

    return next
      .handle(request)
      .pipe(tap((response) => this.handleAuthError(response)));
  }

  private handleAuthError(response: HttpEvent<any>) {
    if (response instanceof HttpResponse && !(response.body instanceof Blob)) {
      const body = response.body;
      if (!body?.status) {
        if (body.status_code === 401 || body.status_code === 403) {
          this.router.navigateByUrl(`/login`);
        }

        throw new HttpErrorResponse({
          error: body?.errors,
          status: body?.status_code,
          statusText: body?.errors[0],
        });
      }
    }
  }
}
